import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Trans, useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UploadRequirementsContent = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2 text-sm text-foreground/90">
      <div className="flex items-start gap-2">
        <Icon name="CheckCircle2" size={16} className="text-success mt-0.5 flex-shrink-0" />
        <p>
          <strong>{t('import.requirements.mandatoryTitle')}</strong>{' '}
          <Trans
            i18nKey="import.requirements.mandatoryBody"
            components={{ code: <code /> }}
          />
        </p>
      </div>
      <div className="flex items-start gap-2">
        <Icon name="CheckCircle2" size={16} className="text-success mt-0.5 flex-shrink-0" />
        <p>
          <strong>{t('import.requirements.formatTitle')}</strong>{' '}
          {t('import.requirements.formatBody')}
        </p>
      </div>
      <div className="flex items-start gap-2">
        <Icon name="CheckCircle2" size={16} className="text-success mt-0.5 flex-shrink-0" />
        <p>
          <strong>{t('import.requirements.linkedinTitle')}</strong>{' '}
          <Trans
            i18nKey="import.requirements.linkedinBody"
            components={{ code: <code /> }}
          />
        </p>
      </div>
      <div className="flex items-start gap-2">
        <Icon name="CheckCircle2" size={16} className="text-success mt-0.5 flex-shrink-0" />
        <p>
          <strong>{t('import.requirements.emailTitle')}</strong>{' '}
          <Trans
            i18nKey="import.requirements.emailBody"
            components={{ code: <code /> }}
          />
        </p>
      </div>
      <div className="flex items-start gap-2">
        <Icon name="CheckCircle2" size={16} className="text-success mt-0.5 flex-shrink-0" />
        <p>
          <strong>{t('import.requirements.phoneTitle')}</strong>{' '}
          <Trans
            i18nKey="import.requirements.phoneBody"
            components={{ code: <code /> }}
          />
        </p>
      </div>
    </div>
  );
};

const UploadInstructions = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) setIsOpen(false);
  };

  return (
    <>
      <Button
        type="button"
        variant="outline"
        iconName="Info"
        onClick={() => setIsOpen(true)}
      >
        {t('import.requirements.button')}
      </Button>

      {isOpen && createPortal(
        <div
          className="fixed inset-0 z-100 flex items-center justify-center bg-black/50 p-4"
          onClick={handleBackdropClick}
          role="dialog"
          aria-modal="true"
          aria-label={t('import.requirements.ariaLabel')}
        >
          <div
            className="bg-card rounded-lg border border-border shadow-elevation-lg max-w-2xl w-full p-6 max-h-[85vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end mb-2">
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label={t('import.requirements.close')}
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <div className="overflow-y-auto -mt-2">
              <UploadRequirementsContent />
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default UploadInstructions;
